var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3685 3.29L20.7085 5.63C21.0985 6.02 21.0985 6.65 20.7085 7.04L18.8785 8.87L15.1285 5.12L16.9585 3.29C17.1485 3.1 17.3985 3 17.6585 3C17.9185 3 18.1685 3.09 18.3685 3.29ZM2.99854 17.25V21H6.74854L17.8085 9.94L14.0585 6.19L2.99854 17.25ZM5.91854 19H4.99854V18.08L14.0585 9.02L14.9785 9.94L5.91854 19Z",
    fill: "#3F46AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePencil);
export default __webpack_public_path__ + "static/media/blue_pencil.8bbfdced7acebe63e7b7a8936358a4ef.svg";
export { ForwardRef as ReactComponent };